import { browserHistory } from 'react-router';
import {
  delay,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import * as api from '../../services/subsidiary/apiSubsidiary';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import { getLocalStorage, setLocalStorage } from '../../utils';

export function* deleteSubsidiarySaga(feathersApp) {
  yield takeEvery('DELETE_SUBSIDIARY', callDeleteSubsidiary, feathersApp);
}

export function* deleteSubsidiaryFromListSaga(feathersApp) {
  yield takeEvery(
    'DELETE_SUBSIDIARY_FROM_LIST',
    callDeleteSubsidiaryFromList,
    feathersApp,
  );
}

export function* fetchListSubsidiarySaga(feathersApp) {
  yield takeLatest(
    'FETCH_LIST_SUBSIDIARY',
    callFetchListSubsidiary,
    feathersApp,
  );
}

export function* fetchSubsidiaryForEditSaga(feathersApp) {
  yield takeEvery(
    'FETCH_SUBSIDIARY_FOR_EDIT',
    callFetchSubsidiaryForEdit,
    feathersApp,
  );
}

export function* saveSubsidiarySaga(feathersApp) {
  yield takeEvery('SAVE_SUBSIDIARY', callSaveSubsidiary, feathersApp);
}

function* callFetchListSubsidiary(feathersApp, action) {
  const { silent, filters } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'subsidiary',
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* callDeleteSubsidiaryFromList(feathersApp, action) {
  yield deleteSubsidiary(feathersApp, action);
  yield delay(2000);
  yield callFetchListSubsidiary(feathersApp, { silent: true });
}

function* callDeleteSubsidiary(feathersApp, action) {
  const result = yield deleteSubsidiary(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/subsidiary');
  }
}

function* deleteSubsidiary(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const { tenant, user } = yield select();
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteSubsidiary, feathersApp, params);
      yield put({
        type: 'DELETE_RECORD_DONE',
        payload: { id, docType: DocType.SUBSIDIARY },
      });
    }
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

function* callSaveSubsidiary(feathersApp, action) {
  const { tenant, user, silent } = yield select();
  const data = { ...action.data };
  if (data) {
    try {
      yield common.showProgressSaveRecord(silent);
      //const isUpdate = data.id ? true : false;
      let result = yield call(api.saveSubsidiary, feathersApp, {
        tenant,
        user,
        data: action.data,
      });
      yield callFetchSubsidiaryForEdit(feathersApp, {
        id: result.id,
        silent: true,
      });
      yield put({ type: 'DISPLAY_SUBSIDIARY' });
      yield put({ type: 'DISPLAY_COMPANY_SUBSIDIARY' });
      browserHistory.push(`/admin/subsidiary/edit/${result.id}`);
      yield common.doneSaveRecord(result, 'Subsidiary was saved');
    } catch (error) {
      yield common.showErrorSaveRecord(error);
    }
  }
}

function* callFetchSubsidiaryForEdit(feathersApp, action) {
  const { path, tenant, user } = yield select();
  const { id, silent } = action;
  try {
    let data;

    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id, path };
      const doc = yield call(api.fetchSubsidiaryById, feathersApp, fetchParams);

      data = doc;
    } else {
      const initialValues = {
        active: true,
      };

      data = initialValues;
    }

    yield common.doneDataById(data);
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

//sets Primary subsidiary based on Employee's Primary Subsidiary
export function* setHeaderbarSubsidiarySaga(feathersApp) {
  yield takeEvery(
    'DISPLAY_SUBSIDIARY',
    callSetHeaderbarSubsidiary,
    feathersApp,
  );
}

export function* callSetHeaderbarSubsidiary(app) {
  try {
    const { user } = yield select();
    const employeeId = (user || {}).id;
    const params = { employeeId };
    const subsidiary = yield call(api.findPrimarySubsidiary, app, params);
    const { id, parent_id, company_logo } = subsidiary;

    setLocalStorage('krisp_primary_subsidiary_id', id);
    setLocalStorage('krisp_primary_subsidiary_logo', company_logo);
    setLocalStorage('krisp_company_primary_subsidiary_id', parent_id);

    yield put({ type: 'SET_PRIMARY_SUBSIDIARY', subsidiary });
  } catch (e) {
    console.error('Unable to set primary subsidiary', e);
  }
}

//sets Primary subsidiary based on List
export function* setPrimarySubsidiarySaga(feathersApp) {
  yield takeEvery(
    'DISPLAY_COMPANY_SUBSIDIARY',
    callSetPrimarySubsidiary,
    feathersApp,
  );
}

export function* callSetPrimarySubsidiary(app) {
  try {
    const primarySubsidiaryId = getLocalStorage('krisp_primary_subsidiary_id');
    const companyPrimarySubsidiaryId = getLocalStorage('krisp_company_primary_subsidiary_id');

    const subsidiaryId = companyPrimarySubsidiaryId || primarySubsidiaryId;
    const subsidiary = yield call(api.fetchSubsidiaryById, app, { id: subsidiaryId });

    const { company_logo } = subsidiary;

    setLocalStorage('krisp_company_primary_subsidiary_logo', company_logo);
    yield put({ type: 'SET_COMPANY_PRIMARY_SUBSIDIARY', subsidiary });
  } catch (e) {
    console.error('Unable to set company primary subsidiary', e);
  }
}
